<template>
  <el-container class="login2" style="color: white">
    <div
      class="d-flex justify-content-end"
      style="text-align: right; padding: 10px"
    >
      <div class="d-flex">
        <el-popover
          placement="top-start"
          title="二维码"
          width="200"
          trigger="hover"
          content="this is content, this is content, this is content"
        >
          <el-image style="width: 100px; height: 100px"></el-image>
          <!-- <i class="iconfont iconlanlvtubiaozhizuomoban-28"
          style="font-size:18px;line-height:16px;" slot="reference"></i> -->
        </el-popover>
        <div style="line-height: 16px;margin-left:4px;font-size:16px; display: none" >扫码下载App</div>
      </div>
    </div>
    <el-main class="d-flex flex-column">
      <el-row type="flex" class="align-items-center">
        <el-col :span="4">
            <!-- <img class="logo-container" src="../assets/images/slogan/logo.png" /> -->
        </el-col>
        <el-col :span="16">
            <div class="title">企业能源管理服务平台</div>
        </el-col>
      </el-row>

      <el-row
        class="none-height flex-grow-1 align-items-stretch"
        type="flex"
        justify="center"
      >
        <el-col
          :span="12"
          class="d-flex flex-column"
          type="flex"
          justify="center"
          align="middle"
        >
          <div
            class="none-height flex-grow-1 d-flex flex-column
            justify-content-center align-items-end"
          >
            <div
              style="
                display: inline-block;
                line-height: 0;
              "
              class="position-relative imgs-container"
            >
              <img
                style="max-height: 100%; max-width: 100%"
                src="../assets/images/login/loginBG.png"
              />
              <img
                src="../assets/images/login/loginBG1b.png"
                class="img1b position-absolute"
              />
              <img
                src="../assets/images/login/loginBGUp.png"
                class="imgUp position-absolute"
              />
              <img
                src="../assets/images/login/loginBGUp.png"
                class="imgUp2 position-absolute"
              />
              <img
                src="../assets/images/login/loginBG2b.png"
                class="img2b position-absolute"
              />
              <img
                src="../assets/images/login/loginBG3.png"
                class="imgBg3 position-absolute"
              />
              <img
                src="../assets/images/login/cloud-logo.png"
                class="imgLogo position-absolute"
              />
            </div>
          </div>
        </el-col>
        <el-col
          :span="12"
          class="d-flex flex-column justify-content-center"
          type="flex"
          justify="center"
          align="middle"
        >
          <div
            style="display: inline-block; line-height: 0; overflow: hidden"
            class="position-relative imgs-container"
          >
            <login-panel style="width: 34rem;height:34rem;"></login-panel>
            <!--
            <div
              class="slogan wave d-flex align-items-end justify-content-center"
              style="margin-top: 1.5rem;margin-bottom:0.8rem; line-height: 3rem; height: 3rem">
              <span style="--wave-item: 1" class="wave-item">
                <img
                  class="slogan-image slogan-yong"
                  src="../assets/images/slogan/yong.png"
                />
              </span>
              <span style="--wave-item: 2" class="wave-item">
                <img
                  class="slogan-image slogan-xin"
                  src="../assets/images/slogan/xin.png"
                />
              </span>
              <span style="--wave-item: 3" class="wave-item">
                <img
                  class="slogan-image slogan-dian"
                  src="../assets/images/slogan/dian.png"
                />
              </span>
              <span style="--wave-item: 4" class="wave-item">
                <img
                  class="slogan-image slogan-liang"
                  src="../assets/images/slogan/liang.png"
                />
              </span>
              <span style="--wave-item: 5" class="wave-item">
                <img
                  class="slogan-image slogan-mei"
                  src="../assets/images/slogan/mei.png"
                />
              </span>
              <span style="--wave-item: 6" class="wave-item">
                <img
                  class="slogan-image slogan-hao"
                  src="../assets/images/slogan/hao.png"
                />
              </span>
              <span style="--wave-item: 7" class="wave-item">
                <img
                  class="slogan-image slogan-sheng"
                  src="../assets/images/slogan/sheng.png"
                />
              </span>
               <span style="--wave-item: 8" class="wave-item">
                <img
                  class="slogan-image slogan-huo"
                  src="../assets/images/slogan/huo.png"
                />
              </span>
            </div> -->
          </div>
        </el-col>
      </el-row>
    </el-main>
    <!-- <el-footer>
      <div>山东电亮亮信息科技有限公司</div>
      <el-row
        type="flex"
        align="bottom"
        justify="center"
        :gutter="12"
      >
        <el-col :span="2.1"><span> 鲁ICP备05311234号-56</span></el-col>
        <el-col :span="1.8"><span class="">©2020-2021</span></el-col>
      </el-row>
    </el-footer> -->
  </el-container>
</template>
<script>
import LoginPanel from '@/components/login/login-panel.vue';

export default {
  name: 'login2',
  components: {
    LoginPanel,
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    submitForm() {
      this.$router.replace({
        name: 'Home',
      });
    },
  },
  created(){
  },
};
</script>
<style scoped>
.logo-container{
  height:30px;
}
.title {
  font-size: 3rem;
  letter-spacing: 4px;
}
.title-logo {
  height: 32px;
  line-height: 30px;
}
.slogan-image {
  width: 3rem;
  height: auto;
}
.slogan-dian {
  margin-left: -8px;
}
.slogan-liang {
  margin-left: -4px;
}
.slogan-mei{
  margin-left:-4px;
}
.slogan-hao {
  margin-left: -14px;
}
.slogan-sheng {
  margin-left: -6px;
}
.slogan-huo {
  margin-left: -6px;
}
.form-container {
  left: 19%;
  right: 30%;
  top: 16%;
  bottom: 12%;
}
.verify-code-image {
  height: 38px;
  width: 100%;
  margin-left: 10px;
  border: solid 1px lightgray;
  border-radius: 4px;
}
.login2 {
  background-image: url(../assets/images/login/bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
.position-relative {
  position: relative;
}
.position-absolute {
  position: absolute;
}
.img1b {
  right: 28%;
  bottom: 20%;
  width: 12%;
  height: auto;
  animation-name: shortupdown;
  animation-duration: 3s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}
.imgUp {
  left: 38%;
  top: 18%;
  width: 20%;
  height: auto;
  animation-name: startFlow;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.imgUp2 {
  left: 36%;
  top: 0%;
  width: 22%;
  height: auto;
  transform:translate(0,10%);
  animation-name: startFlow;
  animation-delay: 0.2s;
  animation-duration: 0.6s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes startFlow {
  form {
    transform: translate(0%, 100%);
  }
  50% {
    opacity: 0.5;
  }
  to {
    opacity: 0;
    transform: translate(0%, -100%);
  }
}
.img2b {
  left: 6.5%;
  bottom: 32%;
  width: 10%;
  height: auto;
  animation-name: shortupdown;
  animation-duration: 3s;
  animation-delay: 0.6s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}
.imgBg3 {
  left: 37%;
  top: 22%;
  width: 20%;
  height: auto;
  animation-name: shortupdown;
  animation-duration: 3s;
  animation-delay: 0.3s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}
.imgLogo {
  left: 30%;
  top: 10%;
  width: 10%;
  height: auto;
  animation-name: shortupdown;
  animation-duration: 3s;
  animation-delay: 0.9s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}
@keyframes shortupdown {
  to {
    transform: translate(0%, -16px);
    opacity: 0.6;
  }
}
.wave span {
  display: inline-block;
  color: #fff;
  font-size: 30px;
  line-height: 0px;
}
.wave .wave-item {
  animation: wave 3s ease-in-out infinite;
  animation-delay: calc(0.1s * var(--wave-item));
  animation-direction: alternate;
  line-height: 3rem;
  padding-bottom: 1rem;
}

@keyframes wave {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  20% {
    transform: translateY(-15px);
    opacity: 1;
  }
  50% {
    transform: translateY(8px);
    opacity: 1;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
